import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { getSeason, SEASONS } from '../lib/season';

const linksFor = (seasonal) => [
  { to: '/', label: 'Sprinklers', end: true, id: 'nav-sprinklers' },
  { to: `/#${seasonal.anchor}`, label: seasonal.navLabel, id: 'nav-seasonal' },
  { to: '/backflow', label: 'Backflow', id: 'nav-backflow' },
  { to: '/#estimate', label: 'Free Estimate', id: 'nav-estimate' },
];

const LOGO = 'https://customer-assets.emergentagent.com/job_backflow-testing/artifacts/pmr3qky5_logo.jpg';

export const SiteNav = () => {
  const [open, setOpen] = useState(false);
  const { pathname, hash } = useLocation();
  const links = linksFor(SEASONS[getSeason()]);
  const isActive = (l) => (l.to.includes('#') ? `${pathname}${hash}` === l.to : pathname === l.to && !hash);
  const renderLinks = (prefix) => links.map((l) => (
    <NavLink key={l.id} to={l.to} end={l.end} onClick={() => setOpen(false)}
      className={() => (isActive(l) ? 'is-active' : '')}
      data-testid={`${prefix}-${l.id}`}>
      {l.label}
    </NavLink>
  ));

  return (
    <nav className="w-nav" data-testid="site-nav">
      <div className="w-nav-inner">
        <Link to="/" className="w-nav-logo" data-testid="nav-logo-button" aria-label="Home">
          <img src={LOGO} alt="PBNJ" />
        </Link>
        <div className="w-nav-links">{renderLinks('desktop')}</div>
        <a href="tel:4695054321" className="w-nav-call" data-testid="nav-call-link">
          <Phone size={16} /> 469-505-4321
        </a>
        <button className="w-nav-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="nav-menu-toggle">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && <div className="w-nav-mobile">{renderLinks('mobile')}</div>}
    </nav>
  );
};

export default SiteNav;
